// extracted by mini-css-extract-plugin
module.exports = {"SectionWrap":"DynamicSwmsContentManagementSection_SectionWrap__1tB9w"};